<template>
  <div class="client-editor">
    <header class="topbar">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" @click="backMainPanel" />
      <div class="topbar-title">
        <div class="kicker">Contabilidad</div>
        <h1>Editar cliente</h1>
        <p class="subtitle">{{ localClientDetails.client_name || "Cliente" }} · {{ localClientDetails.client_ident || "Sin ID" }}</p>
      </div>
      <div class="topbar-actions">
        <button class="btn ghost" type="button" @click="goBack">Cancelar</button>
        <button v-if="canDeleteClient" class="btn danger" type="button" @click="confirmDelete">Eliminar cliente</button>
        <button v-if="canUpdateClient" class="btn primary" type="button" @click="saveClientProfile" :disabled="saving_client">
          <span v-if="!saving_client">Guardar</span>
          <span v-else>Guardando…</span>
        </button>
      </div>
    </header>

    <div class="tabs-wrap">
      <nav class="tabs">
        <button
          v-for="t in tabs"
          :key="t.key"
          class="tab"
          :class="{ active: activeTab === t.key }"
          @click="activeTab = t.key"
        >
          <span class="tab-label">{{ t.label }}</span>
          <span class="tab-hint" v-if="t.hint">{{ t.hint }}</span>
        </button>
      </nav>

      <div class="tab-panel">
        <section v-if="activeTab === 'client'">
          <div class="main-data-container">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos del cliente</h4>
                  <div class="pill">General</div>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">ID</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el ID" v-model="localClientDetails.client_ident" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Nombre</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el nombre" v-model="localClientDetails.client_name" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Teléfono</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el telefono" v-model="localClientDetails.phone" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Estatus</label>
                      <div class="field-control">
                        <select v-model="localClientDetails.client_status">
                          <option :value="1">Activo</option>
                          <option :value="2">Inactivo</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Tipo</label>
                      <div class="field-control">
                        <select v-model="localClientDetails.client_type">
                          <option value="Asistencia">Asistencia</option>
                          <option value="Aseguradora">Aseguradora</option>
                          <option value="Cliente en general">Cliente en general</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Tipo de pago</label>
                      <div class="field-control">
                        <select v-model="localClientDetails.client_internal_payment_type">
                          <option value="80">80 - Error SAT</option>
                          <option value="23">23 - Pago remolque</option>
                          <option value="21">21 - Incobrable</option>
                          <option value="20">20 - Obsoleto</option>
                          <option value="9">9 - Transferencia bancaria</option>
                          <option value="8">8 - Remates</option>
                          <option value="7">7 - Ligada</option>
                          <option value="6">6 - Filial</option>
                          <option value="5">5 - Clave 8</option>
                          <option value="3">3 - Tarjeta de Crédito</option>
                          <option value="4">4 - Crédito</option>
                          <option value="2">2 - Cheque</option>
                          <option value="1">1 - Efectivo</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Límite de crédito</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el límite de crédito" v-model="localClientDetails.client_credit_limit" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Días de crédito</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce los días de crédito" v-model="localClientDetails.client_credit_days" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="maintenance-side">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Opciones</h4>
                </div>
                <div class="container-card-body">
                  <div class="status-grid">
                    <div class="field">
                      <div class="field-control">
                        <div class="toggle">
                          <input id="privileged" type="checkbox" v-model="localClientDetails.is_privileged" />
                          <label for="privileged">Cliente recurrente</label>
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <div class="field-control">
                        <div class="toggle">
                          <input id="retention" type="checkbox" v-model="localClientDetails.applies_retention" />
                          <label for="retention">Aplica retención</label>
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <div class="field-control">
                        <div class="toggle">
                          <input id="suspended" type="checkbox" v-model="localClientDetails.is_credit_suspended" />
                          <label for="suspended">Suspender crédito</label>
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <div class="field-control">
                        <div class="toggle" :class="{ 'toggle--locked': !canManageAllowCredit }">
                          <input
                            id="allow-credit"
                            type="checkbox"
                            :checked="localClientDetails.allow_credit !== false"
                            :disabled="!canManageAllowCredit"
                            :title="canManageAllowCredit ? 'Permitir facturas de crédito' : 'No tienes permiso para cambiar este valor'"
                            @change="setAllowCredit"
                          />
                          <label for="allow-credit">Permitir crédito</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'address'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Dirección</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Calle y número</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la calle" v-model="localClientDetails.client_address.street" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Colonia</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la colonia" v-model="localClientDetails.client_address.neighborhood" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Municipio</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el municipio" v-model="localClientDetails.client_address.city" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Código postal</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el código postal" v-model="localClientDetails.client_address.codigoPostal" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'fiscal'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos fiscales y SAT</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">RFC</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el RFC" v-model="localClientDetails.client_rfc" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Régimen fiscal</label>
                      <div class="field-control">
                        <select id="tax_regime" v-model="localClientDetails.tax_regime">
                          <option value="601">601 - GENERAL DE LEY PERSONAS MORALES</option>
                          <option value="603">603 - PERSONAS MORALES CON FINES NO LUCRATIVOS</option>
                          <option value="605">605 - SUELDOS Y SALARIOS E INGRESOS ASIMILADOS A SALARIOS</option>
                          <option value="606">606 - ARRENDAMIENTO</option>
                          <option value="607">607 - RÉGIMEN DE ENAJENACIÓN O ADQUISICIÓN DE BIENES</option>
                          <option value="608">608 - DEMÁS INGRESOS</option>
                          <option value="609">609 - CONSOLIDACIÓN</option>
                          <option value="610">610 - RESIDENTES EN EL EXTRANJERO SON ESTABLECIMIENTO PERMANENTE EN MÉXICO</option>
                          <option value="611">611 - INGRESOS POR DIVIDENDOS (SOCIOS Y ACCIONISTAS)</option>
                          <option value="612">612 - PRESONAS FÍSICAS CON ACTIVIDADES EMPRESARIALES Y PROFESIONALES</option>
                          <option value="614">614 - INGRESOS POR INTERES</option>
                          <option value="615">615 - RÉGIMEN DE LOS INGRESOS POR OBTENCIÓN DE PREMIOS</option>
                          <option value="616">616 - SIN OBLIGACIONES FISCALES</option>
                          <option value="620">620 - SOCIEDADES COOPERATIVAS DE PRODUCCIÓN QUE OPTAN POR DIFERIR SUS INGRESOS</option>
                          <option value="621">621 - INCORPORACIÓN FISCAL</option>
                          <option value="622">622 - ACTIVIDADES AGRÍCOLAS, GANADERAS, SILVÍCOLAS Y PESQUERAS</option>
                          <option value="623">623 - OPCIONAL PARA GRUPOS DE SOCIEDADES</option>
                          <option value="624">624 - COORDINADOS</option>
                          <option value="625">625 - RÉGIMEN DE LAS ACTIVIDADES EMPRESARIALES CON INGRESOS A TRAVÉS DE PLATAFORMAS TECNOLÓGICAS</option>
                          <option value="626">626 - RÉGIMEN SIMPLIFICADO DE CONFIANZA</option>
                          <option value="628">628 - HIDROCARBUROS</option>
                          <option value="629">629 - DE LOS REGÍMENES FISCALES PREFERENTES Y DE LAS EMPRESAS MULTINACIONALES</option>
                          <option value="630">630 - ENAJENACIÓN DE ACCIONES EN BOLSA DE VALORES</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Método de pago</label>
                      <div class="field-control">
                        <select v-model="localClientDetails.client_payment_method">
                          <option value="PPD">PAGO EN PARCIALIDADES O DIFERIDO</option>
                          <option value="PUE">PAGO EN UNA EXHIBICIÓN</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Forma de pago (SAT)</label>
                      <div class="field-control">
                        <select id="payment-type" v-model="localClientDetails.client_payment_type">
                          <option value="99" v-if="localClientDetails.client_payment_method === 'PPD'">POR DEFINIR</option>
                          <template v-if="localClientDetails.client_payment_method !== 'PPD'">
                            <option value="99">POR DEFINIR</option>
                            <option value="04">TARJETA DE CRÉDITO</option>
                            <option value="03">TRANSFERENCIA</option>
                            <option value="01">EFECTIVO</option>
                            <option value="28">TARJETA DE DÉBITO</option>
                            <option value="02">CHEQUE NOMINATIVO</option>
                          </template>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">CFDI</label>
                      <div class="field-control">
                        <select id="invoice_use" v-model="localClientDetails.client_invoice_use">
                          <option value="G01">ADQUISICIÓN DE MERCANCÍAS</option>
                          <option value="G02">DEVOLUCIOINES, DESCUENTOS O BONIFICACIONES</option>
                          <option value="G03">GASTOS EN GENERAL</option>
                          <option value="I01">CONSTRUCCIONES</option>
                          <option value="I02">MOBILIARIO Y EQUIPO DE OFICINA POR INVERSIONES</option>
                          <option value="I03">EQUIPO DE TRANSPORTE</option>
                          <option value="I04">EQUIPO DE CÓMPUTO Y ACCESORIOS</option>
                          <option value="I05">DADOS, TROQUELES, MOLDES, MATRICES Y HERRAMENTAL</option>
                          <option value="I06">COMUNICACIONES TELEFÓNICAS</option>
                          <option value="I07">COMUNICACIONES SATELITALES</option>
                          <option value="I08">OTRA MAQUINARIA Y EQUIPO</option>
                          <option value="D01">HONORARIOS MÉDICOS, DENTALES Y GASTOS HOSPITALARIOS</option>
                          <option value="D02">GASTOS MÉDICOS POR INCAPACIDAD O DISCAPACIDAD</option>
                          <option value="D03">GASTOS FUNERALES</option>
                          <option value="D04">DONATIVOS</option>
                          <option value="D05">INTERESES REALES EFECTIVAMENTE PAGADOS POR CRÉDITOS HIPOTECARIOS</option>
                          <option value="D06">APORTACIONES VOLUNTARIAS AL SAR</option>
                          <option value="D07">PRIMAS POR SEGUROS DE GASTOS MÉDICOS</option>
                          <option value="D08">GASTOS DE TRANSPORTACIÓN ESCOLAR OBLIGATORIA</option>
                          <option value="D09">DEPÓSITOS EN CUENTAS PARA EL AHORRO</option>
                          <option value="D10">PAGOS POR SERVICIOS EDUCATIVOS</option>
                          <option value="S01">SIN EFECTOS FISCALES</option>
                          <option value="CP01">PAGOS</option>
                          <option value="CN01">NÓMINA</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Clave producto días de pensión</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la clave de producto" v-model="localClientDetails.prefered_product_key_pension_days" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Unidad días de pensión</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la unidad de medida" v-model="localClientDetails.prefered_measurement_unit_pension_days" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Clave producto tráfico</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la clave de producto" v-model="localClientDetails.prefered_product_key_traffic" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Unidad tráfico</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la unidad de medida" v-model="localClientDetails.prefered_measurement_unit_traffic" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Clave producto costo por KM</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la clave de producto" v-model="localClientDetails.prefered_product_key_cost_km" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Unidad costo por KM</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la unidad de medida" v-model="localClientDetails.prefered_measurement_unit_cost_km" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Clave producto maniobras</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la clave de producto" v-model="localClientDetails.prefered_product_key_maneuvers" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Unidad maniobras</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la unidad de medida" v-model="localClientDetails.prefered_measurement_unit_maneuvers" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Clave producto horas de servicio</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la clave de producto" v-model="localClientDetails.prefered_product_key_service_hours" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Unidad horas de servicio</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la unidad de medida" v-model="localClientDetails.prefered_measurement_unit_service_hours" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Leyenda tráfico</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la leyenda (descripción del concepto)" v-model="localClientDetails.prefered_legend_traffic" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Leyenda maniobras</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la leyenda (descripción del concepto)" v-model="localClientDetails.prefered_legend_maneuvers" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Leyenda costo por KM</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la leyenda (descripción del concepto)" v-model="localClientDetails.prefered_legend_cost_km" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Leyenda días de pensión</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la leyenda (descripción del concepto)" v-model="localClientDetails.prefered_legend_pension_days" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Leyenda horas de servicio</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la leyenda (descripción del concepto)" v-model="localClientDetails.prefered_legend_service_hours" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <footer class="savebar">
      <div class="savebar-left">
        <span class="savebar-text">{{ localClientDetails.client_name || "Cliente" }}</span>
      </div>
      <div class="savebar-actions">
        <button class="btn ghost" type="button" @click="goBack">Cancelar</button>
        <button v-if="canDeleteClient" class="btn danger" type="button" @click="confirmDelete">Eliminar</button>
        <button v-if="canUpdateClient" class="btn primary" type="button" @click="saveClientProfile" :disabled="saving_client">
          <span v-if="!saving_client">Guardar</span>
          <span v-else>Guardando…</span>
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

const getDefaultAddress = () => ({
  street: "",
  neighborhood: "",
  city: "",
  codigoPostal: "",
});

const cloneClientDetails = (clientDetails) => {
  if (!clientDetails || typeof clientDetails !== "object") {
    return { client_address: getDefaultAddress() };
  }

  const cloned = JSON.parse(JSON.stringify(clientDetails));
  const address = cloned.client_address;

  cloned.client_address =
    address && typeof address === "object"
      ? { ...getDefaultAddress(), ...address }
      : getDefaultAddress();

  return cloned;
};

export default {
  name: "EditClientProfile",
  props: ["clientDetails", "user_id", "user_groups"],
  data() {
    return {
      permissions: [],
      saving_client: false,
      activeTab: "client",
      tabs: [
        { key: "client", label: "Datos de Cliente", hint: "General / Crédito" },
        { key: "address", label: "Dirección", hint: "Domicilio fiscal" },
        { key: "fiscal", label: "Datos Fiscales", hint: "SAT / Claves" },
      ],
      localClientDetails: cloneClientDetails(this.clientDetails),
    };
  },
  computed: {
    canUpdateClient() {
      return this.hasAnyPerm(["accounting.update_client"]);
    },
    canManageAllowCredit() {
      return this.hasAnyPerm(["accounting.manage_allow_credit"]);
    },
    canDeleteClient() {
      return this.hasAnyPerm(["accounting.delete_client"]);
    },
  },
  watch: {
    clientDetails(newVal) {
      this.localClientDetails = cloneClientDetails(newVal);
    },
  },
  mounted() {
    this.loadPermissions();
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem("userPermissions")) || [];
      } catch (error) {
        this.permissions = [];
      }
    },
    hasPerm(perm) {
      if (!perm) return false;
      if (this.permissions.includes(perm)) return true;
      return this.permissions.includes(`access_control.${perm}`);
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || perms.length === 0) return false;
      return perms.some((perm) => this.hasPerm(perm));
    },
    setAllowCredit(event) {
      if (!this.canManageAllowCredit) {
        event.target.checked = this.localClientDetails.allow_credit !== false;
        return;
      }
      this.localClientDetails.allow_credit = event.target.checked;
    },
    ensureClientAddressShape() {
      if (!this.localClientDetails.client_address || typeof this.localClientDetails.client_address !== "object") {
        this.localClientDetails.client_address = getDefaultAddress();
        return;
      }

      this.localClientDetails.client_address = {
        ...getDefaultAddress(),
        ...this.localClientDetails.client_address,
      };
    },
    backMainPanel() {
      window.location.href = "/main-panel";
    },
    goBack() {
      history.back();
    },
    async saveClientProfile() {
      if (!this.canUpdateClient) {
        Swal.fire("Sin acceso", "No tienes permisos para editar el cliente.", "warning");
        return;
      }
      try {
        const client_id = this.clientDetails.id;
        const apiDirectory = process.env.API_DIRECTORY;
        this.saving_client = true;
        const payload = { ...this.localClientDetails };
        if (!this.canManageAllowCredit) {
          delete payload.allow_credit;
        }
        await axios.put(`${apiDirectory}/client/${client_id}/`, payload);
        Swal.fire("Actualizado", "Los datos del formulario se han actualizado con éxito.", "success");
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Hubo un problema al actualizar los datos del cliente.", "error");
      } finally {
        this.saving_client = false;
      }
    },
    async deleteClient() {
      if (!this.canDeleteClient) {
        Swal.fire("Sin acceso", "No tienes permisos para eliminar el cliente.", "warning");
        return;
      }
      try {
        const client_id = this.clientDetails.id;
        const apiDirectory = process.env.API_DIRECTORY;
        await axios.delete(`${apiDirectory}/client/${client_id}/`);
        Swal.fire("Eliminado", "El cliente ha sido eliminado con éxito.", "success").then(() => {
          window.location.href = "/accounting-module";
        });
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Hubo un problema al eliminar el cliente.", "error");
      }
    },
    confirmDelete() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) this.deleteClient();
      });
    },
  },
  async created() {
    this.localClientDetails = cloneClientDetails(this.clientDetails);
  },
};
</script>

<style scoped>
.client-editor {
  min-height: 100vh;
  background: #e9edf5;
  color: #0f172a;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 14px;
  background: #ffc434;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.16);
}

.logo-button {
  height: 46px;
  cursor: pointer;
}

.topbar-title {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.kicker {
  font-size: 12px;
  opacity: 0.75;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.topbar-title h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 900;
}

.subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  opacity: 0.8;
}

.topbar-actions {
  margin-left: auto;
  display: flex;
  gap: 10px;
}

.tabs-wrap {
  max-width: 1280px;
  margin: 10px auto 76px;
  padding: 0 16px;
}

.tabs {
  display: flex;
  gap: 8px;
  overflow: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
}

.tab {
  border: 1px solid #94a3b8;
  background: #f8fafc;
  border-radius: 10px;
  padding: 8px 10px;
  min-width: 160px;
  text-align: left;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.tab:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
}

.tab.active {
  border-color: #1d4ed8;
  background: #dbeafe;
  box-shadow: 0 6px 14px rgba(29, 78, 216, 0.22);
}

.tab-label {
  display: block;
  font-weight: 900;
  font-size: 12px;
}

.tab-hint {
  display: block;
  font-size: 10px;
  opacity: 0.82;
  margin-top: 2px;
}

.tab-panel {
  margin-top: 10px;
}

.main-data-container {
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 10px;
}

.main-data-container.single-column {
  grid-template-columns: 1fr;
}

.maintenance-main {
  grid-column: span 10;
  display: grid;
  gap: 10px;
}

.maintenance-side {
  grid-column: span 4;
  display: grid;
  gap: 10px;
}

.main-data-container.single-column .maintenance-main,
.main-data-container.single-column .maintenance-side {
  grid-column: 1 / -1;
}

.container-card {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 0;
  border-top: none;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  border-bottom: 1px solid #cbd5e1;
  background: #dbe3ef;
}

.section-title h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
}

.container-card-body {
  padding: 8px;
}

.pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #c7d2fe;
  color: #1e3a8a;
  font-weight: 900;
  font-size: 11px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

@media (max-width: 1400px) {
  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1120px) {
  .main-data-container {
    grid-template-columns: 1fr;
  }
  .maintenance-main,
  .maintenance-side {
    grid-column: 1 / -1;
  }
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 11px;
  font-weight: 900;
  color: #0f172a;
}

.field-control input,
.field-control select,
.field-control textarea {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #94a3b8;
  background: #fff;
  outline: none;
  transition: box-shadow 120ms ease, border-color 120ms ease;
  font-size: 12px;
}

.field-control input:focus,
.field-control select:focus,
.field-control textarea:focus {
  border-color: #1d4ed8;
  box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.18);
}

.status-grid {
  display: grid;
  gap: 10px;
}

.toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 8px;
  border: 1px dashed #64748b;
  background: #eef2ff;
}

.toggle input {
  width: 18px;
  height: 18px;
}

.toggle--locked {
  opacity: 0.72;
}

.toggle--locked input {
  cursor: not-allowed;
}

.btn {
  border: 1px solid #64748b;
  border-radius: 8px;
  padding: 8px 10px;
  font-weight: 900;
  font-size: 12px;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.10);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn.primary {
  background: #1d4ed8;
  color: #fff;
  border-color: #1e40af;
}

.btn.ghost {
  background: #e2e8f0;
}

.btn.danger {
  background: #ef4444;
  color: #fff;
  border-color: #dc2626;
}

.savebar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 25;
  background: rgba(226, 232, 240, 0.96);
  backdrop-filter: blur(10px);
  border-top: 1px solid #94a3b8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
}

.savebar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.savebar-text {
  font-size: 12px;
  opacity: 0.9;
  font-weight: 700;
}

.savebar-actions {
  display: flex;
  gap: 10px;
}
</style>